const frivolousResponseBodySubstrings = [
  // Zscaler, predominantly used by company ID 24117.
  'Zscaler Directory Authentication',
  // OpenDNS, predominantly used by company ID 27605.
  'Site Blocked',
];

export function isFrivolousResponseBody(body: string): boolean {
  return frivolousResponseBodySubstrings.some((substring) => body.includes(substring));
}
